// Angular imports
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';

// Import rxjs
import { Subject, filter, takeUntil } from 'rxjs';

// Import types
import * as CalculationActions from './state-management/calculation-actions';
import { Actions, ofType } from '@ngrx/effects';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();

    constructor(private title: Title,
        private actions$: Actions) { }

    public ngOnInit(): void {

        this.actions$
            .pipe(
                takeUntil(this.unsubscribe$),
                ofType(CalculationActions.loadCalculationSuccess))
            .subscribe(calculation => {
                if (!calculation) return;

                // Set title
                this.title.setTitle([calculation.calculation.meta.projectId, calculation.calculation.meta.description].filter(f => !!f).join(' ') ?? '');
            });

        this.actions$
            .pipe(
                takeUntil(this.unsubscribe$),
                filter(CalculationActions.isErrorAction)
            ).subscribe(err => {
                console.error(err);
            })
    }

    public ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
